import React, { ReactNode } from 'react';
import useActiveTenantFeatureSubscriptions, {
  IActiveTenantFeatureSubscriptionsHook,
} from 'shared/providers/tenant-feature-subscriptions/context/active-tenant-feature-subscriptions-hook';

const ActiveTenantFeatureSubscriptionsContext = React.createContext<IActiveTenantFeatureSubscriptionsHook>({} as never);

interface IProps {
  children: ReactNode;
}

export const ActiveTenantFeatureSubscriptionsProvider = ({ children }: Readonly<IProps>) => {
  return (
    <ActiveTenantFeatureSubscriptionsContext.Provider value={useActiveTenantFeatureSubscriptions()}>
      {children}
    </ActiveTenantFeatureSubscriptionsContext.Provider>
  );
};

export const useActiveTenantFeatureSubscriptionsContextProvider = (): IActiveTenantFeatureSubscriptionsHook =>
  React.useContext<IActiveTenantFeatureSubscriptionsHook>(ActiveTenantFeatureSubscriptionsContext);
